/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SymbolFairPriceDto
 */
export interface SymbolFairPriceDto {
    /**
     * 
     * @type {string}
     * @memberof SymbolFairPriceDto
     */
    selectedMethod: SymbolFairPriceDtoSelectedMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof SymbolFairPriceDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SymbolFairPriceDto
     */
    symbolId: string;
    /**
     * 
     * @type {number}
     * @memberof SymbolFairPriceDto
     */
    peRequiredReturn: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFairPriceDto
     */
    peGrowthRate: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFairPriceDto
     */
    peMultiple: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFairPriceDto
     */
    fcfRequiredReturn: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFairPriceDto
     */
    fcfGrowthRate: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFairPriceDto
     */
    fcfTargetYield: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFairPriceDto
     */
    dcfGrowthRate: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFairPriceDto
     */
    dcfTerminalGrowthRate: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFairPriceDto
     */
    dcfDiscountRate: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFairPriceDto
     */
    dcfMarginOfSafety: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFairPriceDto
     */
    dcfYears: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFairPriceDto
     */
    dcfCash: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFairPriceDto
     */
    dcfDebt: number | null;
    /**
     * 
     * @type {number}
     * @memberof SymbolFairPriceDto
     */
    dcfSharesOutstanding: number | null;
    /**
     * 
     * @type {Date}
     * @memberof SymbolFairPriceDto
     */
    updatedAt: Date;
}

/**
* @export
* @enum {string}
*/
export enum SymbolFairPriceDtoSelectedMethodEnum {
    Pe = 'pe',
    Fcf = 'fcf',
    Dcf = 'dcf'
}

export function SymbolFairPriceDtoFromJSON(json: any): SymbolFairPriceDto {
    return SymbolFairPriceDtoFromJSONTyped(json, false);
}

export function SymbolFairPriceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SymbolFairPriceDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'selectedMethod': json['selectedMethod'],
        'id': json['id'],
        'symbolId': json['symbolId'],
        'peRequiredReturn': json['peRequiredReturn'],
        'peGrowthRate': json['peGrowthRate'],
        'peMultiple': json['peMultiple'],
        'fcfRequiredReturn': json['fcfRequiredReturn'],
        'fcfGrowthRate': json['fcfGrowthRate'],
        'fcfTargetYield': json['fcfTargetYield'],
        'dcfGrowthRate': json['dcfGrowthRate'],
        'dcfTerminalGrowthRate': json['dcfTerminalGrowthRate'],
        'dcfDiscountRate': json['dcfDiscountRate'],
        'dcfMarginOfSafety': json['dcfMarginOfSafety'],
        'dcfYears': json['dcfYears'],
        'dcfCash': json['dcfCash'],
        'dcfDebt': json['dcfDebt'],
        'dcfSharesOutstanding': json['dcfSharesOutstanding'],
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function SymbolFairPriceDtoToJSON(value?: SymbolFairPriceDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'selectedMethod': value.selectedMethod,
        'id': value.id,
        'symbolId': value.symbolId,
        'peRequiredReturn': value.peRequiredReturn,
        'peGrowthRate': value.peGrowthRate,
        'peMultiple': value.peMultiple,
        'fcfRequiredReturn': value.fcfRequiredReturn,
        'fcfGrowthRate': value.fcfGrowthRate,
        'fcfTargetYield': value.fcfTargetYield,
        'dcfGrowthRate': value.dcfGrowthRate,
        'dcfTerminalGrowthRate': value.dcfTerminalGrowthRate,
        'dcfDiscountRate': value.dcfDiscountRate,
        'dcfMarginOfSafety': value.dcfMarginOfSafety,
        'dcfYears': value.dcfYears,
        'dcfCash': value.dcfCash,
        'dcfDebt': value.dcfDebt,
        'dcfSharesOutstanding': value.dcfSharesOutstanding,
        'updatedAt': (value.updatedAt.toISOString()),
    };
}

